<template>
  <a-config-provider :theme="themeConfig">
    <router-view/>
  </a-config-provider>
</template>

<script>
import { themeConfig } from '@/theme';

export default {
  name: 'App',
  data() {
    return { themeConfig };
  }
};
</script>
